// Module
var code = "<a class=\"md-primary\" ng-click=\"$ctrl.goToBundle()\">{{$ctrl.bundle.name}}</a> ";
// Exports
export default code;